import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { createPublicApi } from '../../services/api';

const Footer = () => {
  const { slug } = useParams();
  const base = slug ? `/${slug}` : '';
  const year = new Date().getFullYear();

  const [contact, setContact] = useState({
    address: '123 Coffee Lane, Brew District, NY 10001',
    phone:   '+1 (555) 123-4567',
    email:   'hello@aromacafe.com',
    hours:   'Mon–Fri: 7am – 10pm · Sat–Sun: 8am – 11pm',
    name:    'SwadZone',
    navbar_logo_url: '',
    footer_description: '',
    social_instagram: '',
    social_facebook: '',
    social_twitter: '',
  });

  useEffect(() => {
    if (!slug) return;
    const pubApi = createPublicApi(slug);
    pubApi.settings.get()
      .then(r => {
        const d = r.data.data || {};
        setContact({
          address: d.contact_address || '123 Coffee Lane, Brew District, NY 10001',
          phone:   d.contact_phone   || '+1 (555) 123-4567',
          email:   d.contact_email   || 'hello@aromacafe.com',
          hours:   d.contact_hours   || 'Mon–Fri: 7am – 10pm · Sat–Sun: 8am – 11pm',
          name:    d.navbar_name     || d.cafe_name || 'SwadZone',
          navbar_logo_url: d.navbar_logo_url || '',
          footer_description: d.footer_description || '',
          social_instagram: d.social_instagram || '',
          social_facebook: d.social_facebook || '',
          social_twitter: d.social_twitter || '',
        });
      })
      .catch(() => {});
  }, [slug]);

  const socialLinks = [
    {
      url: contact.social_instagram,
      label: 'Instagram',
      bg: 'linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%)',
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
        </svg>
      ),
    },
    {
      url: contact.social_facebook,
      label: 'Facebook',
      bg: '#1877F2',
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
        </svg>
      ),
    },
    {
      url: contact.social_twitter,
      label: 'Twitter/X',
      bg: '#000000',
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="white" xmlns="http://www.w3.org/2000/svg">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
        </svg>
      ),
    },
  ].filter(s => s.url);

  return (
    <footer style={{ background: '#1c1512' }} className="text-bark-300 mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="md:col-span-2">
            <Link to={`${base}`} className="flex items-center gap-2 mb-5">
              {contact.navbar_logo_url ? (
                <img src={contact.navbar_logo_url} alt="logo" className="w-9 h-9 rounded-xl object-cover" />
              ) : (
                <img src="/favicon-512.png" alt="logo" className="w-9 h-9 rounded-xl object-cover" />
              )}
              <span className="font-display text-xl font-semibold" style={{ color: '#f8f5f1' }}>
                {contact.name || 'SwadZone'}
              </span>
            </Link>
            {contact.footer_description && (
              <p className="text-bark-400 leading-relaxed max-w-xs text-sm">
                {contact.footer_description}
              </p>
            )}
            {socialLinks.length > 0 && (
              <div className="flex gap-3 mt-6">
                {socialLinks.map(({ url, icon, label, bg }) => (
                  <a key={label} href={url} target="_blank" rel="noopener noreferrer"
                    title={label}
                    style={{ background: bg, width: 36, height: 36, borderRadius: 10, display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'opacity 0.2s', opacity: 0.9 }}
                    onMouseOver={e => e.currentTarget.style.opacity = 1}
                    onMouseOut={e => e.currentTarget.style.opacity = 0.9}>
                    {icon}
                  </a>
                ))}
              </div>
            )}
          </div>

          {/* Links */}
          <div>
            <h4 className="font-display text-sm font-semibold mb-5 tracking-widest uppercase" style={{ color: '#f8f5f1' }}>Quick Links</h4>
            <ul className="space-y-2.5">
              {[
                [`${base}`, 'Home'],
                [`${base}/menu`, 'Menu'],
                [`${base}/order`, 'Order Online'],
                [`${base}/reservation`, 'Reserve Table'],
                [`${base}/gallery`, 'Gallery'],
              ].map(([to, label]) => (
                <li key={label}>
                  <Link to={to} onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                    className="hover:text-espresso-400 transition-colors text-sm text-bark-400">
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-display text-sm font-semibold mb-5 tracking-widest uppercase" style={{ color: '#f8f5f1' }}>Visit Us</h4>
            <ul className="space-y-3 text-sm text-bark-400">
              <li className="flex gap-2.5"><span>📍</span><span>{contact.address}</span></li>
              <li className="flex gap-2.5"><span>📞</span><span>{contact.phone}</span></li>
              <li className="flex gap-2.5"><span>✉️</span><span>{contact.email}</span></li>
              <li className="flex gap-2.5">
                <span className="mt-0.5">🕐</span>
                <div>
                  {contact.hours.split('·').map((part, i) => (
                    <div key={i}>{part.trim()}</div>
                  ))}
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-bark-800 mt-12 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-bark-500 tracking-wide">
          <span>© {year} {contact.name || 'SwadZone'}. All rights reserved.</span>
          <Link to={`${base}/admin/login`} className="hover:text-espresso-400 transition-colors uppercase tracking-wider">Admin Panel</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
